import { render, staticRenderFns } from "./NovaCard.vue?vue&type=template&id=29c70355&lang=pug&"
import script from "./NovaCard.vue?vue&type=script&lang=js&"
export * from "./NovaCard.vue?vue&type=script&lang=js&"
import style0 from "./NovaCard.vue?vue&type=style&index=0&id=29c70355&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports